import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Message } from '../classes/message';
import { Observable } from 'rxjs';
import { io } from 'socket.io-client';
import { UsersService } from './users.service';
import { UserGroup, User } from '../classes/user';
import { HttpClientModule,HttpClient } from '@angular/common/http';
import { GlobalSearchService } from './globalsearchservice.service';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';

@Injectable({
	providedIn: 'root'
})
export class OmsService {


	key = 'UET6DFMPAXW7BKCB';
	config: any;
	//todo make connection reusabel
	socket: any;
	details: any;
	user : any = [];
	environment = {
		production: false,
		SOCKET_ENDPOINT: 'wss://cleve.tireserv.com:5009',
		user: '',
	};
	package: any = '';

	// Connection state management
	connectionState: 'disconnected' | 'connecting' | 'connected' | 'error' = 'disconnected';
	connectionAttempts = 0;
	maxConnectionAttempts = 5;
	healthCheckInterval: any = null;
	lastPingTime = 0;

	constructor(public userService: UsersService, private http: HttpClient, private globalSearchService: GlobalSearchService,private _configSvc: RuntimeConfigLoaderService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})

		this.globalSearchService.user.subscribe( (result) => {
			this.user = result;
		});

		this.environment.SOCKET_ENDPOINT = this.config.apiServer.socket,
		this.environment.user = this.user.user.userid;

		this.globalSearchService.socket.subscribe( existingsocket => {
			if(existingsocket) {
				this.socket = existingsocket;
				this.adoptSocket();
			}
		});
	}

	/**
	 * Wire this service's state onto a socket it did NOT create.
	 *
	 * ChatService builds the socket as soon as user data lands and publishes it
	 * on globalSearchService.socket, so by the time anything else calls
	 * setupSocketConnection the socket already exists and the `if(!this.socket)`
	 * branch that registers the handlers is skipped. `connectionState` then sat
	 * on 'disconnected' for the life of the session and isSocketHealthy() said
	 * dead on a perfectly live socket — which is why the pick station fell back
	 * to HTTP and the board stopped mirroring counts.
	 *
	 * Idempotent: the marker keeps the handlers from stacking each time the
	 * BehaviorSubject replays.
	 */
	private adoptSocket(): void {
		if (!this.socket || this.socket.__omsAdopted) { return; }
		this.socket.__omsAdopted = true;
		this.setupConnectionEventHandlers();
		// An adopted socket may already be connected, in which case its `connect`
		// event fired before these handlers existed and will never fire again.
		if (this.socket.connected) {
			this.connectionState = 'connected';
			this.startHealthMonitoring();
		}
	}

	/**
	 * The socket URL for the config in force RIGHT NOW.
	 *
	 * Not the constructor-captured `environment.SOCKET_ENDPOINT`: the config
	 * loads asynchronously and can be swapped at runtime by the tenant picker, so
	 * a value read once at construction is whatever happened to be loaded that
	 * instant — often the build's default rather than the tenant on screen.
	 */
	private socketEndpoint(): string {
		const live = this.config && this.config.apiServer && this.config.apiServer.socket;
		return live ? live : this.environment.SOCKET_ENDPOINT;
	}

	/**
	 * True when the socket we hold is dialling a different host than the current
	 * config wants — i.e. it was built for another tenant, or before the tenant
	 * picker switched.
	 *
	 * Left alone, that socket keeps working against the OLD server: pick events
	 * would broadcast into the previous tenant's OrderBoard room while the user
	 * is looking at a different company. Compared on origin, not the whole URI,
	 * so a ws/wss or path difference to the same host is not churned.
	 */
	private socketIsForAnotherHost(endpoint: string): boolean {
		const current = this.socket && this.socket.io && this.socket.io.uri;
		if (!current || !endpoint) { return false; }
		const host = (u: string) => {
			try {
				return new URL(u.replace(/^ws/, 'http')).host;
			} catch (e) {
				return u;
			}
		};
		return host(current) !== host(endpoint);
	}

	setupSocketConnection(token: string) {

		const endpoint = this.socketEndpoint();

		if (this.socket && this.socketIsForAnotherHost(endpoint)) {
			// Drop it and rebuild against the right host below. The rebuild
			// republishes on globalSearchService.socket, which is how ChatService
			// and everything else holding the stale reference pick up the new one.
			try {
				this.socket.removeAllListeners();
				this.socket.disconnect();
			} catch (e) { /* already gone */ }
			this.socket = null;
			this.connectionState = 'disconnected';
			this.stopHealthMonitoring();
		}

		if(!this.socket) {

			if(!this.user) {
				token = this.randomString(12, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
			} else {
				token = this.user.user.userid;
			}

			this.socket = io(endpoint, {
				auth: { token },
				reconnection: true,
				reconnectionAttempts: 5,
				reconnectionDelay: 1000,
				reconnectionDelayMax: 5000,
				timeout: 20000,
				forceNew: false
			});

			// Add comprehensive connection event handling
			this.socket.__omsAdopted = true;
			this.setupConnectionEventHandlers();

			this.globalSearchService.socket.next(this.socket);
		}

		this.globalSearchService.socket.subscribe((results: any[]) => {
			this.socket = results;
			// Covers the socket built elsewhere — without this its connect event
			// is never observed here and the health check reads dead.
			this.adoptSocket();
			if (this.socket && !this.socket.connected) {
				this.socket.connect();
			}
		});
	}

	// Connection event handlers for better reliability
	private setupConnectionEventHandlers(): void {
		if (!this.socket) {return;}

		// Connection established
		this.socket.on('connect', () => {
			this.connectionState = 'connected';
			this.connectionAttempts = 0;
			console.log('Socket connected successfully');
			this.startHealthMonitoring();
		});

		// Connection lost
		this.socket.on('disconnect', (reason: string) => {
			this.connectionState = 'disconnected';
			console.log('Socket disconnected:', reason);
			this.stopHealthMonitoring();

			// If it's a server disconnect, try to reconnect
			if (reason === 'io server disconnect') {
				this.socket.connect();
			}
		});

		// Connection error
		this.socket.on('connect_error', (error: any) => {
			this.connectionState = 'error';
			this.connectionAttempts++;
			console.error('Socket connection error:', error);

			// If we've exceeded max attempts, reset and try again
			if (this.connectionAttempts >= this.maxConnectionAttempts) {
				console.log('Max connection attempts reached, resetting...');
				this.connectionAttempts = 0;
				setTimeout(() => {
					if (this.socket) {
						this.socket.connect();
					}
				}, 5000);
			}
		});

		// Reconnection attempts
		this.socket.on('reconnect_attempt', (attemptNumber: number) => {
			this.connectionState = 'connecting';
			console.log(`Reconnection attempt ${attemptNumber}`);
		});

		// Reconnection successful
		this.socket.on('reconnect', (attemptNumber: number) => {
			this.connectionState = 'connected';
			this.connectionAttempts = 0;
			console.log(`Reconnected after ${attemptNumber} attempts`);
		});

		// Reconnection failed
		this.socket.on('reconnect_failed', () => {
			this.connectionState = 'error';
			console.error('Reconnection failed after all attempts');
		});

		// Ping/pong for connection health monitoring
		this.socket.on('pong', (latency: number) => {
			console.log(`Socket ping: ${latency}ms`);
		});
	}

	// Get current connection state
	getConnectionState(): string {
		return this.connectionState;
	}

	/**
	 * Whether the socket can carry a write right now.
	 *
	 * `socket.connected` is the authoritative runtime flag; `connectionState` is
	 * this service's own bookkeeping and can lag it (or miss it entirely for a
	 * socket created elsewhere). Gating on the bookkeeping meant callers with a
	 * live socket were told it was dead, so every count silently took the HTTP
	 * fallback and nothing broadcast to the board. Report the socket, and keep
	 * connectionState for describing *why* it's down.
	 */
	isSocketHealthy(): boolean {
		return !!(this.socket && this.socket.connected);
	}

	waitForSocketConnection(timeoutMs?: number): Promise<void> {
		const token = this.user?.user?.userid || this.user?.userid || '';
		if (!this.socket) {
			this.setupSocketConnection(token);
		}
		const socket = this.socket;
		if (!socket) {
			return Promise.reject(new Error('Socket not initialized'));
		}
		if (socket.connected && this.connectionState === 'connected') {
			return Promise.resolve();
		}
		const effectiveTimeoutMs = typeof timeoutMs === 'number' && timeoutMs > 0
			? timeoutMs
			: (socket.io?.opts?.timeout ?? 20000);

		return new Promise((resolve, reject) => {
			let resolvedOrRejected = false;
			const cleanup = () => {
				socket.off('connect', handleConnect);
				socket.off('connect_error', handleError);
				clearTimeout(timeoutId);
			};
			const handleConnect = () => {
				if (resolvedOrRejected) {return;}
				resolvedOrRejected = true;
				cleanup();
				resolve();
			};
			const handleError = (error: any) => {
				if (resolvedOrRejected) {return;}
				resolvedOrRejected = true;
				cleanup();
				reject(error || new Error('Socket connection error'));
			};
			const timeoutId = setTimeout(() => {
				if (resolvedOrRejected) {return;}
				resolvedOrRejected = true;
				cleanup();
				reject(new Error('Socket connection timeout'));
			}, effectiveTimeoutMs);

			socket.on('connect', handleConnect);
			socket.on('connect_error', handleError);

			if (!socket.connected) {
				socket.connect();
			}
		});
	}

	// Force reconnection
	forceReconnect(): void {
		if (this.socket) {
			this.connectionState = 'connecting';
			this.socket.disconnect();
			this.socket.connect();
		}
	}

	// Start connection health monitoring
	startHealthMonitoring(): void {
		if (this.healthCheckInterval) {
			clearInterval(this.healthCheckInterval);
		}

		this.healthCheckInterval = setInterval(() => {
			if (this.socket && this.socket.connected) {
				this.lastPingTime = Date.now();
				this.socket.emit('ping');

				// Check if we haven't received a pong in 30 seconds
				setTimeout(() => {
					if (Date.now() - this.lastPingTime > 30000) {
						console.warn('Socket health check timeout, forcing reconnection');
						this.forceReconnect();
					}
				}, 30000);
			}
		}, 30000); // Ping every 30 seconds
	}

	// Stop connection health monitoring
	stopHealthMonitoring(): void {
		if (this.healthCheckInterval) {
			clearInterval(this.healthCheckInterval);
			this.healthCheckInterval = null;
		}
	}

	// Handle message receive event
	subscribeToMessages = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if(!this.socket.connected) {
			this.joinRoom('messages');
		}

		this.socket.on('messagesent', msg => {
			return cb(null, msg);
		});
	}

	subscribeToRecScanUpdate = (cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		// Ensure connection is established before joining room
		if (!this.isSocketHealthy()) {
			console.warn('Socket not healthy, attempting to reconnect...');
			this.forceReconnect();
		}

		this.joinRoom('RecScanUpdate');
		this.socket.on('recscansent', msg => {
			return cb(null, msg);
		});

		this.socket.on('recscanupdated', msg => {
			return cb(null, msg);
		});
	}

	sendRecScanUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		// Ensure connection is healthy before sending
		if (this.isSocketHealthy()) {
			this.socket.emit('recscansent', { data , roomName }, cb);
		} else {
			console.warn('Socket not healthy, cannot send rec scan update');
			if (cb) {cb(new Error('Socket not connected'));}
		}
	}

	subscribeToDriverChange = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		this.joinRoom('driverchange');

		this.socket.on('welcome', msg => {
			return cb(null, msg);
		});

		this.socket.on('driverchanged', msg => {
			return cb(null, msg);
		});
	}

	/**
	 * Pick-floor activity — claimed, released, started, completed.
	 *
	 * Deliberately its own event rather than riding an existing relay: the socket
	 * is a single app-wide instance (ChatService creates it), so every
	 * `socket.on` in the app is registered on the same connection. Reusing
	 * another feature's outgoing name — even scoped to a different room — would
	 * fire that feature's handler too.
	 *
	 * No joinRoom: the server puts every socket in 'OrderBoard' at connect, and
	 * its `join` switch only honours RecScanUpdate and Users, so asking for a
	 * bespoke room would quietly leave the room empty.
	 */
	subscribeToPickActivity = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		this.socket.on('pickactivityupdate', msg => {
			return cb(null, msg);
		});
	}

	/**
	 * Relay only — whatever happened is already written over HTTP. Never send a
	 * count through here, and never announce one of these through
	 * sendOrderPickUpdate: that endpoint writes.
	 */
	sendPickActivity = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('pickactivity', { data , roomName }, cb);}
	}

	sendDriverUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('driverchanged', { data , roomName }, cb);}
	}

	subscribeToCarts = (cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		this.joinRoom('CartRoom');

		this.socket.on('cartupdate', msg => {
			return cb(null, msg);
		});

		this.socket.on('updatecarts', msg => {
			return cb(null, msg);
		});
	}

	subscribeToTerminalStatus = (terminalId: number, cb: Function) => {
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid);
		}

		this.joinRoom(`terminal_${terminalId}`);

		this.socket.on('terminal_status', (msg: any) => {
			if (msg.terminal_id === terminalId) {
				return cb(null, msg);
			}
		});

		this.socket.on('payment_status_update', (msg: any) => {
			return cb(null, msg);
		});

		this.socket.on('terminal_health_update', (msg: any) => {
			if (msg.terminal_id === terminalId) {
				return cb(null, msg);
			}
		});
	};

	subscribeToTerminalUpdates = (transactionId: string, cb: Function) => {
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid);
		}

		this.joinRoom(`transaction_${transactionId}`);

		this.socket.on('payment_status_update', (msg: any) => {
			if (msg.transaction_id === transactionId) {
				return cb(null, msg);
			}
		});

		this.socket.on('terminal_transaction_started', (msg: any) => {
			if (msg.transaction_id === transactionId) {
				return cb(null, msg);
			}
		});
	};

	sendCartUpdate = ({ data, roomName }, cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('cartupdate', { data , roomName }, cb);}
	}

	subscribeToCards = (cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		this.joinRoom('OrderBoard');

		this.socket.on('dispatchupdate', msg => {
			return cb(null, msg);
		});

		this.socket.on('cardupdate', msg => {
			return cb(null, msg);
		});

		this.socket.on('orderupdate', msg => {
			return cb(null, msg);
		});

		this.socket.on('pickupdate', msg => {
			 return cb(null, msg);
		});

		this.socket.on('orderitempick', msg => {
			 return cb(null, msg);
		});

		this.socket.on('loadbayupdate', msg => {
			console.log(msg);
			return cb(null, msg);
		})
	}

	subscribeToPuts = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		this.socket.on('pickupdate', msg => {
			return cb(null, msg);
		});
	}

	subscribeToPicks = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		this.socket.on('pickupdate', msg => {
			return cb(null, msg);
		});
	}

	subscribeToOrderPicks = (cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		this.socket.on('orderitempick', msg => {
			return cb(null, msg);
		});
	}

	subscribeToOrderUpdates = (cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		this.socket.on('orderupdate', msg => {
			return cb(null, msg);
		});
	}

	sendOrderCheckUpdate = ({ data, roomName }, cb) => {


		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('orderitemcheck', { data , roomName }, cb);}

	}

	sendOrderPickUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('orderitempick', { data , roomName }, cb);}
	}

	subscribeToOpenOrders = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		this.socket.on('openorders', msg => {
			return cb(null, msg);
		});
	}

	printCommandSent = false;

	setNewOrder() {
		this.printCommandSent = false;
	}

	setPrintedOrder() {
		this.printCommandSent = true;
	}

	getPrintStatus(){
		return this.printCommandSent;
	}

	// 	sendPrintCommand = ({ data, roomName }, cb) => {
	// 		if (!this.socket) {
	// 			this.setupSocketConnection(this.user.user.userid);
	// 		}
	//
	// 		if (this.socket && !this.printCommandSent) {
	//
	// 			this.socket.emit('printPdf', { data, roomName }, () => {
	//
	// 				if (this.socket) {
	// 					this.socket.disconnect();
	// 					this.socket = null;
	// 				}
	// 				if (cb) {
	// 					cb();
	// 				}
	// 				// Set printCommandSent to false after everything is done
	// 				this.printCommandSent = false;
	// 			});
	// 			this.printCommandSent = true; // Mark command as sent
	// 		} else {
	// 			console.log("Print command already sent or socket not available.");
	// 		}
	// 	}

	sendPrintCommand = ({ data, roomName }, cb) => {

		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid);
		}

		if (this.socket && !this.printCommandSent) {
			// alert('sending');
			//"Sending print command...");
			console.log('sent');
			this.socket.emit('printPdf', { data, roomName }, () => {

				if (this.socket) {
					this.socket.disconnect();
					this.socket = null;
					this.printCommandSent = true;
					console.log('Socket disconnected.');
				}
				if (cb) {
					cb();

					if(this.socket) {
						this.socket.disconnect();
						this.socket = null;
						this.printCommandSent = true;
						console.log('Socket disconnected Again.');
					}
				}
			});
		} else {
			//"Print command already sent or socket not available.");
		}
	}

	sendOrderUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('orderupdate', { data , roomName }, cb);}

	}

	sendOpenOrderUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('openorders', { data , roomName }, cb);}

	}

	sendSnoozeUpdate = ({ data, roomName }, cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('snoozekupdate', { data , roomName }, cb);}

	}

	sendSnoozeRemove = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('snoozeremove', { data , roomName }, cb);}

	}

	sendCreditUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('creditupdate', { data , roomName }, cb);}
	}

	sendAutoPutUpdate= ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('putautoupdate', { data , roomName }, cb);}
	}

	rgaAutoPutUpdate= ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('rgaautoupdate', { data , roomName }, cb);}
	}
	sendPutUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('putupdate', { data , roomName }, cb);}
	}

	sendPickUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('pickupdate', { data , roomName }, cb);}
	}

	sendMessage = ({ message, roomName }, cb) => {
		if (this.socket) {this.socket.emit('message', { message , roomName }, cb);}
	}

	sendCardUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('updatecard', { data, roomName }, cb);}
	}

	sendDispatchUpdate = ({ data, roomName }, cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('dispatchupdate', { data, roomName }, cb);}
	}

	sendDispatchPositionUpdate = ({ data, roomName }, cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('dispatchpositionupdate', { data, roomName }, cb);}
	}

	sendLoadSheet = ({ data, roomName }, cb) => {
		if(!this.socket){
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('loadsheetupdate', { data, roomName }, cb);}
	}


	loadingBayAssigned = ({ data, roomName }, cb) => {
		if(!this.socket){
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('bayassigned', { data, roomName }, cb);}
	}

	subscribeToLoadingBays = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if(!this.socket.connected) {
			this.joinRoom('loadingbays');
		}
		this.socket.on('bayassigned', msg => {
			return cb(null, msg);
		});
	}

	subscribeToBayScans = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if(!this.socket.connected) {
			this.joinRoom('scanners');
		}
		this.socket.on('loadbayScan', msg => {
			return cb(null, msg);
		});
	}

	sendBayScan = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('loadbayScan', { data, roomName }, cb);}
	}
	sendTruckClearedAlert = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('truckcleared', { data, roomName }, cb);}
	}

	sendWillCallAlert = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('willcallorder', { data, roomName }, cb);}
	}

	subscribeToTruckClearAlerts = (cb) => {
		if(!this.socket){
			this.setupSocketConnection(this.user.user.userid)
		}

		this.joinRoom('truckalerts');

		this.socket.on('truckcleared', msg => {
			return cb(msg);
		})
	}

	subscribeToWillCallAlerts = (cb) => {
		if(!this.socket){
			this.setupSocketConnection(this.user.user.userid)
		}

		this.joinRoom('truckalerts');

		this.socket.on('willcallorder', msg => {
			return cb(msg);
		})
	}

	joinRoom = (roomName) => {
		this.socket.emit('join', roomName);
	}

	public getConnection() {
		this.globalSearchService.socket.subscribe((results: any[]) => {
			this.socket = results;
		});
	}

	//HTTP REQUESTS
	public getPicks() {
		const method = 'oms/pick';
		return this.http.get(this.setEndPoint(method));
	}

	public getOrderCards() {
		const method = 'oms/cards';
		return this.http.get(this.setEndPoint(method));
	}

	public getRunPick(column: any) {
		const method = 'oms/runpick&column='+column;
		return this.http.get(this.setEndPoint(method));
	}

	public getRecalc(column) {
		const method = 'oms/recalc&column='+column+this.getKey();
		return this.http.get(this.setEndPoint(method));
	}

	private getApi() {
		return this.config.apiServer.crossPoint;
	}

	private getPackage() {
		const p = sessionStorage.getItem('app')
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	private getApiKey() {
		return '&key='+this.config.apiCredentials.clientId+'&userid='+this.user.user.userid;
	}

	public getKey() {
		return '&apikey='+this.key+'&userid='+this.user.user.userid;
	}

	private setEndPoint(method: any) {
		return this.setEndPoint(method)+this.getApiKey()+ this.getPackage()
	}

	disconnect() {
		if (this.socket) {
			this.socket.disconnect();
			this.socket.connect();
		}
	}

	disconnectOnly(){
		if(this.socket){
			this.socket.disconnect();
			this.socket = false;
			console.log('disconnected from socket');
		}
	}

	randomString(length: any, chars: any) {
		let result = '';
		for (let i = length; i > 0; --i) {result += chars[Math.floor(Math.random() * chars.length)];}
		return result;
	}

	sendloadscan = ({ data, roomName }, cb) => {
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) { this.socket.emit('loadbayScanWifi', { data, roomName }, cb); }
	}

	sendloadbayupdate = ({ data, roomName }, cb) => {
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) { this.socket.emit('loadbayUpdate', { data, roomName }, cb); }
	}


	subscribeToBayScanResults = (cb) => {
		this.disconnect()
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (!this.socket.connected) {
			this.joinRoom('scanners');
		}
		this.socket.on('loadbayScanResult', msg => {
			return cb(null, msg);
		});
	}

	subscribeToBayScanUpdates = (cb) => {
		this.disconnect()
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (!this.socket.connected) {
			this.joinRoom('scanners');
		}
		this.socket.on('loadbayScanUpdate', msg => {
			return cb(null, msg);
		});
	}


	sendStickerscan = ({ data, roomName }, cb) => {
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) { this.socket.emit('loadbayScanSticker', { data, roomName }, cb); }
	}

	subscribeToStickerScanResults = (cb) => {
		this.disconnect()
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (!this.socket.connected) {
			this.joinRoom('scanners');
		}
		this.socket.on('loadbayStickerResult', msg => {
			return cb(null, msg);
		});
	}

}
